import React from 'react';
import { PLAN_INFO } from '../../config/contract';

const PlanCard = ({ selected, onChange }) => {
  return (
    <div className="plan-list">
      {PLAN_INFO.map((p) => {
        const isSel = selected === p.id;
        return (
          <div
            key={p.id}
            className={`plan-row ${isSel ? 'selected' : ''}`}
            onClick={() => onChange(p.id)}
          >
            <div className="plan-row-radio">
              <span className="plan-row-radio-dot" />
            </div>

            <div className="plan-row-rank" style={{ color: p.color }}>
              {p.rank}
            </div>

            <div className="plan-row-days">
              <span className="plan-row-num">{p.days}</span>
              <span className="plan-row-unit">Days</span>
            </div>

            <div className="plan-row-stat">
              <div className="plan-row-stat-value text-green">{p.dailyROI}</div>
              <div className="plan-row-stat-label">Daily ROI</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PlanCard;
